import { useState, useEffect } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import OrbitalLoader from './OrbitalLoader'

interface PremiumLoaderProps {
  message?: string
  size?: 'sm' | 'md' | 'lg'
  messages?: string[]
}

export default function PremiumLoader({
  message = 'Chargement...',
  size = 'md',
  messages
}: PremiumLoaderProps) {
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0)

  // Rotate messages if array provided
  useEffect(() => {
    if (!messages || messages.length === 0) return

    const interval = setInterval(() => {
      setCurrentMessageIndex((prev) => (prev + 1) % messages.length)
    }, 2500) // Change message every 2.5 seconds

    return () => clearInterval(interval)
  }, [messages])

  // Size configurations
  const sizeConfig = {
    sm: {
      diameter: 40,
      border: 3,
      textSize: 'text-xs'
    },
    md: {
      diameter: 60,
      border: 4,
      textSize: 'text-sm'
    },
    lg: {
      diameter: 80,
      border: 4,
      textSize: 'text-base'
    }
  }

  const config = sizeConfig[size]
  const displayMessage = messages && messages.length > 0 ? messages[currentMessageIndex] : message

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="flex flex-col items-center justify-center py-8"
    >
      {/* Orbital loader */}
      <OrbitalLoader size={size} />

      {/* Message with fade animation */}
      <AnimatePresence mode="wait">
        <motion.p
          key={displayMessage}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.3 }}
          className={`mt-6 text-riseup-gray-400 light:text-gray-600 ${config.textSize} font-medium text-center px-4`}
        >
          {displayMessage}
        </motion.p>
      </AnimatePresence>
    </motion.div>
  )
}
